// extracted by mini-css-extract-plugin
export default {"containerCarousel":"Carousel_containerCarousel__eEsYH"};